<template>
  <div>
    <DetailIndex :fabricExpenseCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-fabricExpenseRequest',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
